<template>
  <div @click="openModal" class="service-card">
    <figure v-html="data.icon" class="service-card__icon" />
    <div class="service-card__line" />
    <h4>{{ data.title }}</h4>
    <span class="service-card__subtitle">{{ data.description }}</span>
    <span class="service-card__route"
      >Подробнее
      <IconComponent name="arrow-right" />
    </span>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import ServicesModal from "components/modal/components/ServicesModal.vue";
export default {
  name: "ServiceCard",
  props: {
    data: {
      type: Object,
    },
  },
  methods: {
    openModal() {
      this.$store.state._modals.push({
        component: ServicesModal,
        options: {
          data: this.data,
        },
      });
    },
  },
  components: { IconComponent },
};
</script>

<style lang="stylus">
.service-card {
  display flex
  flex-direction column
  justify-content center
  align-items center
  gap 26px
  background var(--white)
  padding 30px 38px
  border-radius var(--main-radius)
  cursor pointer

  +below(1024px) {
    gap 18px
    padding 16px
  }

  &:hover {
    .service-card__route {
      color: var(--main);
      svg path {
        fill var(--main)
      }
    }
  }

  &__icon {
    width 80px
    height 80px
    border-radius var(--small-radius)

    +below(1024px) {
      width: 50px;
      height: 50px;
    }
  }

  &__line {
    border 1px solid var(--gray-2)
    width 100%
  }

  &__subtitle {
    font-weight: 400;
    font-size: 1.25em;
    line-height: 32px;
    text-align: center;
    color: var(--black);

    +below(1024px) {
      font-size: 0.75em;
      line-height: 160%;
    }
  }

  &__route {
    cursor pointer
    display flex
    gap 4px
    align-items: center;
    font-weight: 500;
    font-size: 1.25em;
    line-height: 160%;
    color: var(--red);
    transition var(--transition)

    +below(1024px) {
      font-size: 0.625em;
      line-height: 160%;
    }

    &:hover {
      color: var(--main);
       svg path {
          fill var(--main)
        }
    }
    svg {
      width: 22px;
      path {
        fill var(--red)
        transition var(--transition)
      }

      +below(1024px) {
        width: 12px;
      }
    }
  }
}
</style>
